
/**
 * Genera un UUID válido usando crypto.randomUUID() cuando está disponible,
 * o una alternativa compatible en navegadores más antiguos
 */
export function generateUUID(): string {
  // Usar crypto.randomUUID si está disponible (moderno)
  if (window.crypto && 'randomUUID' in window.crypto) {
    return window.crypto.randomUUID();
  }
  
  // Implementación de fallback para navegadores más antiguos
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = Math.random() * 16 | 0;
    const v = c === 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
}

/**
 * Valida si un string es un UUID válido
 */
export function isValidUUID(str: string): boolean {
  if (!str) return false;
  
  // RegExp para validar formato UUID
  const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
  
  return uuidRegex.test(str);
}
